import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {
  getAge,
  formatPatientName,
  formatPronouns
} from '../../helpers/patients';
import { truncate } from '../../helpers/stringUtils';

import CreateConsolidatedFormButton from './CreateConsolidatedFileButton';
import MessageUserButton from '../messages/MessageUserButton';
import PatientSessionsButton from './PatientSessionsButton';
import PatientStatus from './PatientStatus';
import PatientPayerPlansButton from './PatientPayerPlansButton';
import SchedulePatientButton from './SchedulePatientButton';
import ViewPatientButton from './ViewPatientButton';
import ViewPatientCasesButton from './ViewPatientCasesButton';
import CustomBox from "../common/CustomBox";

const PatientSummary = props => {
  const { patient: p } = props;
  if (!p) return <></>;
  return (
    <CustomBox>
      <Stack spacing={1} padding={2}>
        <Stack direction='row' justifyContent='space-between'>
          <Stack spacing={1}>
            <Typography variant='h2'>
              {formatPatientName(p)}
            </Typography>
            <Stack direction='row' spacing={1} alignItems='center'>
              <Typography variant='large600Tight' color='text.light'>
                Age:
              </Typography>
              <Typography variant='large'>
                {getAge(p)}
                {p.personal_pronouns
                  ? ` ${formatPronouns(p)}`
                  : null
                }
              </Typography>
            </Stack>
          </Stack>
          <Stack justifyContent='start'>
            <PatientStatus patient={p} />
          </Stack>
        </Stack>
        <Stack 
          direction='row' 
          spacing={0.5}
          sx={{
            '& button:first-child': {
              paddingLeft: 0
            }
          }}
        >
          <SchedulePatientButton iconOnly patient={p} />
          <MessageUserButton iconOnly patient={p} />
          <PatientSessionsButton iconOnly patient={p} />
          {
            props.hideDetails
              ? null
              : <ViewPatientButton iconOnly patient={p} />
          }
          {
            props.showCases
            ? <ViewPatientCasesButton iconOnly patient={p} />
            : null
          }
          <PatientPayerPlansButton iconOnly patient={p} />       
          <CreateConsolidatedFormButton iconOnly patientId={p.id} />   
        </Stack>
      </Stack>
    </CustomBox>
  );
};

PatientSummary.propTypes = {
  patient: PropTypes.object,
  hideDetails: PropTypes.bool,
  showCases: PropTypes.bool,
};

export default PatientSummary;
